import EsgPlatformFooter from './EsgPlatformFooter';

export default EsgPlatformFooter;
